export default __webpack_public_path__ + "static/media/D5.a8044dda.png";